import * as yup from 'yup';

export default yup.object({
    integration_idn: yup.string().required('Integration is a required field'),
    connector_idn: yup.string().required('Connector is a required field')
});
